class VideoPlayer {
  constructor (video) {
    this.screen = null;
    this.pointMobile = 989;
    this.videoMobile = null;
    this.videoDesctop = null;
    this.video = video.querySelector("video");
    this.stopPlay = null;
    this.groupContainer = null;
  }

  initVariable () {
    this.videoContainer = this.video.closest(".js-video");
    this.btnAction = this.videoContainer.querySelector(".js-video-action");
    this.btnActionMute = this.videoContainer.querySelector(".js-video-mute");
    this.clientEvent = false;
    this.stopPlay = this.videoContainer.dataset.stopPlay;
    this.groupContainer = this.videoContainer.dataset.groupContainer;

  }

  playVideo () {
    this.btnAction.classList.replace("stop", "play");
    this.video.play();
    if (!this.clientEvent) this.clientEvent = false;
  }

  muteVideo () {
    if (!this.btnActionMute) return false;
    this.btnActionMute.addEventListener("click", () => {
      if (this.video.muted) {
        this.btnActionMute.classList.remove("mute");
      } else {
        this.btnActionMute.classList.add("mute");
      }
      this.video.muted = !this.video.muted;
    });
  }

  stopVideo () {
    this.btnAction.classList.replace("play", "stop");
    this.video.pause();
  }

  stopVideoGroup () {
    const video = document.querySelector(`[data-group-container="${this.groupContainer}"] .play`)

    if(video) {
      video.closest(".js-video").querySelector('video').pause()
      video.classList.replace("play", "stop");
    }
  }
  toggleVideo () {
    this.btnAction.addEventListener("click", () => {
      this.clientEvent = true;
      if (this.btnAction.classList.contains("stop")) {
        if(this.groupContainer) this.stopVideoGroup();
        this.playVideo(this.btnAction);
      } else {
        this.stopVideo(this.btnAction);
      }
      if(this.stopPlay) {
        this.video.muted = false;
      }
    });
  }

  checkIsVisible () {
    const elementRect = this.video.getBoundingClientRect();
    const top = elementRect.top < 0 && (elementRect.top + elementRect.height > 0);
    const bottom = elementRect.bottom > 0 && elementRect.bottom - elementRect.height <= ((window.innerHeight || document.documentElement.clientHeight));

    const isVisible = (
      elementRect.left >= 0 &&
      (top || bottom)
    );
    if (!this.clientEvent && this.btnAction && !this.stopPlay) {
      if (isVisible && this.btnAction.classList.contains("stop")) {
        this.playVideo();
      }
    }

    if (!isVisible && this.btnAction?.classList.contains("play")) {
      this.stopVideo();
    }
  }

  scrollVideo () {
    document.addEventListener("scroll", () => {
      this.checkIsVisible();
    });
  }

  setScreen () {
    let screenWidth = window.innerWidth >= this.pointMobile ? "desktop" : "mobile";
    if (screenWidth !== this.screen) {
      this.screen = screenWidth;
      this.setScreenVideo();
    }
  }

  initVideoMobile () {
    this.videoMobile = this.video.dataset.mobile;
    if (!this.videoMobile) return false;
    this.videoDesctop = this.video.querySelector("source").src;
    this.screen = window.innerWidth >= this.pointMobile ? "desktop" : "mobile";
    this.setDefaultScreenVideo();
    window.addEventListener("resize", () => {
     this.setScreen()
    });
  }

  setDefaultScreenVideo () {
         this.setScreenVideo();
  }
  setScreenVideo () {
    this.video.querySelector("source").src = this.screen == "desktop" ? this.videoDesctop : this.videoMobile;
    this.video.load();
  }

  initVideo () {
    this.initVideoMobile();
    this.initVariable();
    this.video.value = 3;
    this.checkIsVisible();
    if (this.btnAction) {
      this.toggleVideo();
    } else {
      this.video.play();
    }
    this.muteVideo();
    this.scrollVideo();
    this.initEventEnded();
  }

  reInitVideo () {
    this.initVariable();
    this.initVideo();
  }

  initEventEnded() {
   const isLoop = this.video.hasAttribute('loop');
    if(!isLoop) {
      this.video.addEventListener("ended", (event) => {
        this.stopVideo();
      })
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-video-slider")) return;
  else {
    document.querySelectorAll(".js-video").forEach((video) => {
      const videoPlayer = new VideoPlayer(video);
      videoPlayer.initVideo();
    });
  }

});

function reInitVideoPlayer () {
  const videos = document.querySelectorAll(".js-video");
  if (!videos) return;
  videos.forEach((video) => {
    const videoPlayer = new VideoPlayer(video);
    videoPlayer.initVideo();
  });
}
